// inv/src/components/ui/CTAHover.jsx
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { languagePrefixes } from '../../i18n';

const CTAHover = ({
  text,
  href,
  onClick,
  align = 'left',
  className = '',
  bgColor = 'bg-yellow-400',
  textColor = 'text-stone-800',
  hoverTextColor = 'text-white'
}) => {
  const { i18n } = useTranslation();
  const currentLanguage = (i18n.language || 'en').split('-')[0];
  const prefix = languagePrefixes[currentLanguage] || '';
  const cleanHref = href.startsWith('/') ? href.slice(1) : href;
  const adjustedHref = `${prefix}/${cleanHref}`;

  const alignmentClass =
    align === 'center'
      ? 'justify-center'
      : align === 'right'
        ? 'justify-end'
        : 'justify-start';

  return (
    <div className={`flex ${alignmentClass} items-center`}>
      <Link
        to={adjustedHref}
        onClick={onClick}
        className={`group relative inline-flex items-center font-medium no-underline ${className}`}
      >
        <span className="-mx-4 absolute left-0 right-8 h-8">
          <span
            className={`block w-full h-full ${bgColor} rounded-l-full transform scale-x-0 origin-right transition-transform duration-300 ease-in-out group-hover:scale-x-100`}
          />
        </span>

        <span className="relative z-10 flex items-center">
          <span
            className={`absolute transition-opacity duration-300 ${hoverTextColor} opacity-0 group-hover:opacity-100`}
          >
            {text}
          </span>
          <span
            className={`transition-opacity duration-300 ${textColor} group-hover:opacity-0`}
          >
            {text}
          </span>
        </span>

        <span
          className={`relative z-10 ml-2 flex items-center rounded-full justify-center w-12 h-8 ${bgColor} overflow-hidden transition-transform duration-300 group-hover:translate-x-1`}
        >
          <svg
            className="w-5 h-5 text-current transition-transform duration-300 group-hover:translate-x-1"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path d="M13 7l5 5-5 5M5 12h14" />
          </svg>
        </span>
      </Link>
    </div>
  );
};

export default CTAHover;
